import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

/**
 * API типы для personal_acc_front
 */

/** Область API: какой baseQuery и правила 401 применять */
export enum ApiScope {
    Public = 'public',
    Private = 'private',
    Reg = 'reg',
}

/** Скоуп по пути запроса (относительно `API_BASE_URL`, т.е. после `/api/v1`) */
export function resolveApiScope(url: string): ApiScope {
    if (url.startsWith('/public/') || url === '/public') {
        return ApiScope.Public;
    }
    if (url.startsWith('/reg/') || url === '/reg') {
        return ApiScope.Reg;
    }
    return ApiScope.Private;
}

// Общие типы для всех endpoints
export type ApiBaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>;
export type ApiTagTypes = 'Customer' | 'Mails' | 'MailSettings' | 'Rooms' | 'RegCustomer' | 'Kyc';
